import { render, staticRenderFns } from "./sdworkerimage.vue?vue&type=template&id=19603f56&"
import script from "./sdworkerimage.vue?vue&type=script&lang=js&"
export * from "./sdworkerimage.vue?vue&type=script&lang=js&"
import style0 from "./sdworkerimage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports